import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	fetchUser,
	resetAuth
} from '../../../actions';

import Button from '@material-ui/core/Button';
import ForwardICon from '@material-ui/icons/Forward';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
	singInButton: {
		marginRight: theme.spacing.unit,
	},
	textField:{
		width:'100%',
		marginBottom:15
	}
});


class login extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			inputData : {
				submit: false,
				user_id : '',
				password : ''
			},
			error : null,
			showPassword : false
		}
	}

	_handleClickShowPassword(){
		this.setState({ showPassword: !this.state.showPassword });
	}


	
	
	_onClickSubmit(){
		const {dispatch} = this.props;
		dispatch(resetAuth());
		const data = this.state.inputData;
		const user_id = String(data.user_id).trim();
		const password = String(data.password).trim();
		const submit = data.submit;
		if(!user_id || !password){
			this.setState({
				error : 'SDS認証ID/パスワードを入力してください'
			});
		}
		else if(!submit){
			this.setState({
				error : '同意チェックボックスをONにしてください'
			});
		}
		else{
			dispatch(fetchUser({
				user_id,
				password
			}));
		}
	}
	
	_handleChange(event) {
		let inputData = this.state.inputData;
		switch (event.target.name) {
			case 'user_id':
				inputData.user_id = event.target.value;
				break;
			case 'password':
				inputData.password = event.target.value;
				break;
			case 'submit':
				inputData.submit = !inputData.submit;
				break;
			default:
				break;
		}
		this.setState({
			inputData
		});
	}
	
	_handleKeyPress(event){
		if(event.key !== 'Enter'){
			return
		}
		const inputData = this.state.inputData;
		let user_id = inputData.user_id;
		let password = inputData.password;
		switch (event.target.name) {
			case 'user_id':
				this.password.focus();
				break;
			case 'password':
				if(user_id && password){
					this._onClickSubmit();
				}
				else{
					this.password.focus();
				}
				break;
			default:
				break;
		}
	}


	render () {
		const { classes } = this.props;
		const auth = this.props.auth;
		const error = (auth.error) ? auth.error : this.state.error;
		return (
			<div id="login_area">
				<div className="login_main_box">
					<h2><i className="material-icons">
						lock_open
					</i>ログイン</h2>
					<TextField
						label="SDS認証ID"
						placeholder="SDS認証ID"
						className={classes.textField}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						name="user_id"
						inputRef={field => this.user_id = field}
						inputProps={{
							maxLength:20
						}}
						autoFocus={true}
					/>
					<TextField
						label="パスワード"
						placeholder="パスワード"
						className={classes.textField}
						type={this.state.showPassword ? 'text' : 'password'}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						InputProps={{
						endAdornment:(
							<InputAdornment position="end">
								<IconButton
									aria-label="Toggle password visibility"
									onClick={this._handleClickShowPassword.bind(this)}
								>
									{this.state.showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>
						)
						}}
						inputProps={{
							maxLength:20
						}}
						name="password"
						inputRef={field => this.password = field}
					/>

					<div className="login_cautions">
						<div className="login_caution_text">
							<p>WEBからのSDSのダウンロードについて、お客様の同意を頂いております。</p>
							<h4>同意して頂ける場合は、下のボックスにチェックを入れて下さい。</h4>
						</div>
					</div>
					
					<div className="btn_area clearfix">
						<FormControlLabel
							control={
								<Checkbox
									checked={this.state.inputData.submit}
									onChange={this._handleChange.bind(this)}
									value="checkedB"
									color="primary"
									name="submit"
								/>
							}
							label="WEBでのSDSの提供に同意します"
							className="fl_left"
						/>
						<Button variant="contained" color="primary" className="fl_right" onClick={this._onClickSubmit.bind(this)}>
							<ForwardICon className={classes.singInButton} />
							ログイン
						</Button>
					</div>
					
					{error &&
					<div className="caution_area">
						<i className="fa fa-exclamation-triangle" aria-hidden="true" />
						<p>{error}</p>
					</div>
					}
					<p className="copyright fsm5 ta_center">ADEKA CLEAN AID CORPORATION</p>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(login);



// WEBPACK FOOTER //
// ./src/routes/top/components/login.js